import { SPACE_PASSWORD_RATE_LIMITED_ERROR_CODE } from "./space-password.js";
import { SPACE_FILE_ERROR_CODES } from "./space-files.js";
import { CENTER_AGENT_ROUTINE_ERROR_CODES } from "./center-agent-routines.js";
import { ORGANIZATION_SKILL_ERROR_CODES } from "./organization-skills.js";
import { FEEDBACK_SUBMIT_ERROR_CODES } from "./feedback.js";
import { commonErrorSchema } from "../common/error-response.js";
import { CENTER_AGENT_CONTEXT_ERROR_CODES } from "./center-agent-context-manifest.js";
import { MESSAGE_CHANNEL_ERROR_CODES } from "./message-channels.js";
import { ORGANIZATION_DOCUMENT_ERROR_CODES } from "./organization-documents.js";
import { PLUGIN_ERROR_CODES } from "./plugin-access.js";
import { SPACE_TASK_ERROR_CODES } from "./space-tasks.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/gateway-error.ts
const trimmedNonEmptyStringSchema = z$1.string().trim().min(1);
const SPACE_ADDRESSING_TARGET_INVALID_ERROR_CODE = "space.addressing.target_invalid";
const gatewayErrorCodeSchema = z$1.enum([
	"bad_request",
	"upstream_error",
	"upstream_unreachable",
	"invalid_json",
	"invalid_payload",
	"invalid_device_id",
	"invalid_space_id",
	"hello_required",
	"gateway.misconfigured",
	"auth.invalid_origin",
	"auth.unauthenticated",
	"account.avatar.conflict",
	"account.avatar.content_mismatch",
	"account.avatar.invalid_image",
	"account.avatar.profile_not_found",
	"account.avatar.storage_failed",
	"account.avatar.too_large",
	"account.avatar.transform_failed",
	"account.avatar.type_unsupported",
	"profile.not_found",
	"profile.invalid_input",
	...FEEDBACK_SUBMIT_ERROR_CODES,
	"organization.context_required",
	"organization.context_unavailable",
	"organization.membership_required",
	"organization.role_required",
	"usage.store_unavailable",
	...MESSAGE_CHANNEL_ERROR_CODES,
	...ORGANIZATION_DOCUMENT_ERROR_CODES,
	...ORGANIZATION_SKILL_ERROR_CODES,
	...PLUGIN_ERROR_CODES,
	"connector.organization_context_changed",
	"organization.logo.conflict",
	"organization.logo.content_mismatch",
	"organization.logo.forbidden",
	"organization.logo.invalid_image",
	"organization.logo.metadata_invalid",
	"organization.logo.not_found",
	"organization.logo.personal_unsupported",
	"organization.logo.storage_failed",
	"organization.logo.too_large",
	"organization.logo.transform_failed",
	"organization.logo.type_unsupported",
	"organization_binding_authorization.binding_required",
	"organization_binding_authorization.no_bindings",
	"organization_binding_authorization.preference_unavailable",
	"organization_binding_authorization.profile_org_mismatch",
	"organization_binding_authorization.profile_owner_mismatch",
	"agent_profile_binding.model_not_supported",
	"agent_profile_binding.reasoning_level_not_supported",
	"center_agent.designation_required",
	"center_agent.designation_store_unavailable",
	"center_agent.not_designated",
	"center_agent.permission_required",
	"center_agent.profile_binding_required",
	"center_agent.profile_org_mismatch",
	"center_agent.profile_invalid",
	"center_agent.profile_not_found",
	"center_agent.audit_store_unavailable",
	"center_agent.dm_open_failed",
	...CENTER_AGENT_CONTEXT_ERROR_CODES,
	...CENTER_AGENT_ROUTINE_ERROR_CODES,
	"slack.workspace_already_bound",
	"slack.organization_already_bound",
	"slack.workspace_not_connected",
	"slack.identity_link_account_required",
	"slack.identity_link_token_invalid",
	"slack.identity_link_membership_required",
	"slack.identity_already_linked",
	"direct_message.open_failed",
	"direct_message.self_not_allowed",
	"direct_message.target_not_found",
	"direct_message.conversion_required",
	"connected_computer.enrollment_invalid",
	"device.forgotten",
	"invalid_password_payload",
	"space.not_found",
	"space.forbidden",
	"space.join.human_profile_required",
	"space.join.private",
	"space.organization_mismatch",
	"space.human_confirmation_required",
	"space.leave_space.creator_forbidden",
	"space.members.creator_forbidden",
	"space.members.current_profile_forbidden",
	"space.membership_required",
	SPACE_ADDRESSING_TARGET_INVALID_ERROR_CODE,
	"space.wake.client_message_id_required",
	"space.wake.handoff_seed_failed",
	"space.wake.target_invalid",
	"space.wake_progress.store_unavailable",
	"space_index.store_unavailable",
	"space.password_required",
	"space.password_invalid",
	SPACE_PASSWORD_RATE_LIMITED_ERROR_CODE,
	"space.password_too_short",
	"space.access_mode.password_not_configured",
	"space.publication_mode.owner_required",
	"space.publication_mode.password_not_configured",
	...SPACE_FILE_ERROR_CODES,
	...SPACE_TASK_ERROR_CODES,
	"attachment_too_large",
	"attachment_type_unsupported",
	"attachment_content_mismatch",
	"attachment_not_found",
	"attachment_reference_invalid",
	"attachment_storage_failed",
	"diagnostic_report.reported_signal_not_found",
	"diagnostic_report.store_unavailable",
	"start.session.retired",
	"prepare.session.navigation_action_already_started",
	"prepare.session.not_found",
	"prepare.session.revision_conflict",
	"prepare.session.store_unavailable",
	"prepare.session.terminal_stale",
	"prepare.session.token_invalid"
]);
const gatewayErrorSchema = commonErrorSchema.extend({
	code: gatewayErrorCodeSchema,
	requestId: trimmedNonEmptyStringSchema,
	upstreamCode: trimmedNonEmptyStringSchema.optional()
});
const gatewayErrorEnvelopeSchema = z$1.strictObject({
	ok: z$1.literal(false),
	error: gatewayErrorSchema
});
//#endregion
export { SPACE_ADDRESSING_TARGET_INVALID_ERROR_CODE, gatewayErrorCodeSchema, gatewayErrorEnvelopeSchema };

//# sourceMappingURL=gateway-error.js.map